var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "note-list-table" },
    [
      _c("b-table", {
        attrs: {
          fields: _vm.fields,
          items: _vm.tableItems,
          responsive: "",
          "select-mode": "single",
          selectable: "",
          striped: "",
          "tbody-tr-class": _vm.rowClass,
        },
        scopedSlots: _vm._u([
          {
            key: "head()",
            fn: function (data) {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(data.label.toUpperCase()) +
                    "\n        "
                ),
              ]
            },
          },
          {
            key: "cell(note)",
            fn: function (data) {
              return [
                data.item.hasPriority
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn-note-priority mr-3",
                        attrs: { title: "Priorisierung aufheben" },
                        on: {
                          click: function ($event) {
                            return _vm.unsetPriority(data.item.id)
                          },
                        },
                      },
                      [_vm._v("\n                PRIO\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "break-lines" }, [
                  _vm._v(_vm._s(data.value)),
                ]),
              ]
            },
          },
          {
            key: "cell(dates)",
            fn: function (data) {
              return [
                _c("table", [
                  _c("tr", [
                    _c("td", { staticClass: "noteDateLabel" }, [
                      _vm._v(
                        "\n                        Hinzugefügt\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "noteDateValue" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.formatDateTime(data.value.dateSet)) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  data.value.dateReminder
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "noteDateLabel topBorder dateReminder",
                          },
                          [
                            _vm._v(
                              "\n                        Wiedervorlage\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "noteDateValue topBorder dateReminder",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.formatDate(data.value.dateReminder)
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.value.dateDeadline
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "noteDateLabel topBorder dateDeadLine",
                          },
                          [
                            _vm._v(
                              "\n                        Frist\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "noteDateValue topBorder dateDeadLine",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.formatDate(data.value.dateDeadline)
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }